import React from "react";
import { useField } from "formik";
import { shape } from "prop-types";

import Error from "src/shared/components/Error";
import listingProps from "src/shared/utilities/graphql/listingProps";
import useAbTests from "src/shared/utilities/useAbTests";

import analytics from "../../utilities/analytics";
import useActiveExperts from "../../utilities/hooks/useActiveExperts";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import ContactFormFooter from "../ContactFormFooter";
import ExpertContainer from "../ExpertContainer";
import ExpertModal from "../ExpertModal";
import BuyerSellerSwitch from "./BuyerSellerSwitch";
import * as S from "./styled";

const EMAIL_TYPE = "email";
export const TEXT_TYPE = "text";
export const TEXTAREA_TYPE = "textarea";

const ContactForm = ({ listing }) => {
  const {
    fossa_contact_box_email_input_update: abTestVariant,
    loading: abTestsLoading
  } = useAbTests("fossa_contact_box_email_input_update");

  const { expertsApiUuid } = useFeatureState();
  const { expert } = useActiveExperts();
  const [, { error }] = useField("form_submission");

  const onBuySellSwitchChange = event => {
    const buySellChoice =
      event.target.value === "buy" ? "select_buy" : "select_sell";
    const { id: contactId, is_pro: isPro } = expert.contact;

    analytics({
      action: "building_expert_event",
      isHdp: false,
      label: `${buySellChoice}|expert_contact_id=${contactId}|pro=${isPro}|uuid=${expertsApiUuid}`
    });
  };

  if (abTestsLoading) return null;

  const showNewEmailInput = abTestVariant === "new";

  return (
    <>
      <S.Wrapper>
        <S.Container data-testid="contact-box-form">
          <ExpertContainer />

          {!listing && (
            <BuyerSellerSwitch onChangeValue={onBuySellSwitchChange} />
          )}

          <S.Input labelText="Name" name="name" required type={TEXT_TYPE} />
          <S.Input
            labelText="Phone Number"
            name="phone"
            required
            type={TEXT_TYPE}
          />
          {showNewEmailInput ? (
            <S.Input label="Email" name="email" required type={EMAIL_TYPE} />
          ) : (
            <S.Input labelText="Email" name="email" required type={TEXT_TYPE} />
          )}
          <S.Input
            labelText="Message"
            name="body"
            required
            type={TEXTAREA_TYPE}
          />

          {error && <Error>{error}</Error>}
        </S.Container>

        <ContactFormFooter listing={listing} />
      </S.Wrapper>

      <ExpertModal />
    </>
  );
};

ContactForm.propTypes = {
  listing: shape(listingProps)
};

ContactForm.defaultProps = {
  listing: null
};

export default ContactForm;
